/* ============================================================
   YOOME EXTRAS
   - Wish list: hearts on products save them to a list kept on the
     shopper's device ("Letter to Santa" at Christmas). The list can be
     shared as a link (/?wishlist=handle,handle&from=Name) that opens
     the same drawer for family to buy from.
   - Free-shipping progress bar in the cart ("$23 to go!").
   ============================================================ */
(function () {
  'use strict';

  var Y = window.Yoome || {};
  var xmas = !!Y.christmas;
  var KEY = 'yhWish';
  var NAME_KEY = 'yhWishName';

  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(cents) {
    if (Y.formatMoney) return Y.formatMoney(cents);
    return '$' + (cents / 100).toFixed(2);
  }
  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { /* private mode or storage blocked: the list just lasts for this visit */ }
    return null;
  }

  // ---- A small message at the bottom of the screen ----
  var toastTimer = null;
  function toast(html, action) {
    var el = document.getElementById('YhToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'YhToast';
      el.className = 'yh-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<span>' + html + '</span>' + (action ? '<button type="button">' + esc(action.label) + '</button>' : '');
    if (action) el.querySelector('button').addEventListener('click', function () { el.classList.remove('is-on'); action.run(); });
    window.requestAnimationFrame(function () { el.classList.add('is-on'); });
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { el.classList.remove('is-on'); }, 3600);
  }

  /* ---------------- Wish list ---------------- */
  var list = [];
  try { list = JSON.parse(store(KEY) || '[]') || []; } catch (e) { list = []; }
  function save() { store(KEY, JSON.stringify(list)); }
  function has(handle) { return list.some(function (x) { return x.h === handle; }); }

  var drawer = document.querySelector('[data-yh-wish-drawer]');
  var overlay = document.querySelector('[data-yh-wish-overlay]');
  var listEl = drawer && drawer.querySelector('[data-yh-wish-list]');
  var lastFocus = null;
  var shared = null;

  function itemFrom(btn) {
    var d = btn.dataset;
    return { h: d.handle, t: d.title, p: d.price, i: d.image, u: d.url, v: d.variant || '' };
  }

  function syncHearts() {
    $$('[data-yh-heart]').forEach(function (btn) {
      var on = has(btn.dataset.handle);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var text = btn.querySelector('[data-yh-heart-text]');
      if (text) text.textContent = on
        ? (xmas ? 'Added to my letter to Santa' : 'Saved to my wish list')
        : (xmas ? 'Add to my letter to Santa' : 'Save to my wish list');
    });
    $$('[data-yh-wish-count]').forEach(function (c) {
      c.textContent = list.length;
      c.hidden = list.length === 0;
      c.style.display = list.length ? 'flex' : 'none';
    });
  }

  function toggle(item) {
    if (!item || !item.h) return false;
    var on;
    if (has(item.h)) {
      list = list.filter(function (x) { return x.h !== item.h; });
      on = false;
    } else {
      list.unshift(item);
      on = true;
    }
    save();
    syncHearts();
    if (drawer && drawer.classList.contains('is-open') && !shared) render();
    $$('[data-yh-wish-count]').forEach(function (c) {
      c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
    });
    if (on) {
      toast(xmas ? 'Added to your letter to Santa ✉️' : 'Saved to your wish list ♡', { label: 'See list', run: function () { open(); } });
    }
    return on;
  }

  function row(item, mine) {
    var buy = item.v
      ? '<button type="button" class="yh-wish__add product-card__quick-add" data-variant-id="' + esc(item.v) + '">Add to bag</button>'
      : '<a class="yh-wish__add" href="' + esc(item.u) + '">View</a>';
    return '<li class="yh-wish__item">' +
      '<a class="yh-wish__img" href="' + esc(item.u) + '">' + (item.i ? '<img src="' + esc(item.i) + '" alt="" width="120" height="120" loading="lazy">' : '') + '</a>' +
      '<div class="yh-wish__info"><a class="yh-wish__name" href="' + esc(item.u) + '">' + esc(item.t) + '</a><p class="yh-wish__price">' + esc(item.p) + '</p></div>' +
      '<div class="yh-wish__acts">' + buy +
        (mine ? '<button type="button" class="yh-wish__remove" data-yh-wish-remove="' + esc(item.h) + '" aria-label="Remove ' + esc(item.t) + '">&times;</button>' : '') +
      '</div></li>';
  }

  function render() {
    if (!drawer) return;
    var items = shared ? shared.items : list;
    var mine = !shared;
    listEl.innerHTML = items.map(function (it) { return row(it, mine); }).join('');
    drawer.querySelector('[data-yh-wish-empty]').hidden = items.length > 0;
    drawer.querySelector('[data-yh-wish-foot]').hidden = !mine || items.length === 0;
    drawer.querySelector('[data-yh-wish-shared-foot]').hidden = mine;
    var title = drawer.querySelector('[data-yh-wish-title]');
    var intro = drawer.querySelector('[data-yh-wish-intro]');
    if (shared) {
      title.textContent = xmas ? 'Dear Santa…' : 'A wish list for you';
      intro.textContent = shared.from
        ? (xmas ? 'A letter to Santa from ' + shared.from + ' ✉️ Tap anything to make their Christmas.' : shared.from + "'s wish list. Tap anything to make their day.")
        : (xmas ? 'Someone shared their letter to Santa with you ✉️' : 'Someone shared their wish list with you.');
      if (!items.length) intro.textContent = 'Hmm, the gifts on this list have sold out or moved. Have a browse instead!';
    } else {
      title.textContent = xmas ? 'Dear Santa…' : 'My wish list';
      intro.textContent = xmas ? "This Christmas, I'd really love…" : "Things I'm dreaming of…";
    }
    var nameInput = drawer.querySelector('[data-yh-wish-name]');
    if (nameInput && !nameInput.value) nameInput.value = store(NAME_KEY) || '';
  }

  function open(sharedList) {
    if (!drawer) return;
    shared = sharedList || null;
    render();
    lastFocus = document.activeElement;
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    var note = document.getElementById('YhToast');
    if (note) note.classList.remove('is-on');
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      var closeBtn = drawer.querySelector('[data-yh-wish-close]');
      if (closeBtn) closeBtn.focus();
    });
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    window.setTimeout(function () { drawer.hidden = true; if (overlay) overlay.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function shareLink() {
    var nameInput = drawer.querySelector('[data-yh-wish-name]');
    var name = nameInput ? nameInput.value.trim() : '';
    store(NAME_KEY, name);
    var url = window.location.origin + '/?wishlist=' + list.map(function (x) { return encodeURIComponent(x.h); }).join(',') + (name ? '&from=' + encodeURIComponent(name) : '');
    // theme preview: keep the link on the previewed theme, so it can be tested before publishing
    var theme = window.Shopify && window.Shopify.theme;
    if (theme && theme.id && theme.role && theme.role !== 'main') url += '&preview_theme_id=' + theme.id;
    var text = xmas
      ? (name ? name + "'s letter to Santa" : 'My letter to Santa') + ' from Yoome 🎄'
      : (name ? name + "'s wish list" : 'My wish list') + ' from Yoome ♡';
    // phones and tablets get the share sheet (Messages, WhatsApp…); computers copy the link
    var touch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    if (touch && navigator.share) {
      navigator.share({ title: text, text: text, url: url }).catch(function () { /* closed the share sheet */ });
      return;
    }
    var btn = drawer.querySelector('[data-yh-wish-share]');
    var done = function () {
      toast('Link copied! Paste it into a message to family 💌');
      if (!btn) return;
      if (!btn.dataset.label) btn.dataset.label = btn.innerHTML;
      btn.textContent = 'Link copied ✓';
      window.clearTimeout(btn._yhTimer);
      btn._yhTimer = window.setTimeout(function () { btn.innerHTML = btn.dataset.label; }, 2400);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copy this link:', url); });
    } else {
      window.prompt('Copy this link:', url);
    }
  }

  function addAll() {
    var items = list.filter(function (x) { return x.v; }).map(function (x) { return { id: parseInt(x.v, 10), quantity: 1 }; });
    var skipped = list.length - items.length;
    if (!items.length) { toast('These need a size or colour choice first. Tap one to choose.'); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add'); return d; }); })
      .then(function () {
        close();
        if (Y.openCart) Y.openCart(); else window.location.href = '/cart';
        if (skipped) window.setTimeout(function () { toast(skipped + (skipped === 1 ? ' item needs' : ' items need') + ' a size or colour choice, so they stayed on your list.'); }, 600);
      })
      .catch(function (e) { toast(esc(e.message || 'Sorry, something went wrong. Please try again.')); });
  }

  if (drawer) {
    document.addEventListener('click', function (e) {
      var heart = e.target.closest('[data-yh-heart]');
      if (heart) {
        e.preventDefault();
        var on = toggle(itemFrom(heart));
        if (on) { heart.classList.remove('is-pop'); void heart.offsetWidth; heart.classList.add('is-pop'); fly(heart); }
        hideTip(true);
        return;
      }
      if (e.target.closest('[data-yh-wish-tip-close]')) hideTip(true);
      if (e.target.closest('[data-yh-wish-open]')) { open(); return; }
      if (e.target.closest('[data-yh-wish-close]') || e.target === overlay) { close(); return; }
      var rm = e.target.closest('[data-yh-wish-remove]');
      if (rm) { toggle({ h: rm.getAttribute('data-yh-wish-remove') }); render(); return; }
      if (e.target.closest('[data-yh-wish-share]')) { shareLink(); return; }
      if (e.target.closest('[data-yh-wish-addall]')) { addAll(); return; }
      if (e.target.closest('[data-yh-wish-mine]')) { shared = null; render(); return; }
      // buying from the list: close it so the bag drawer is in view
      if (drawer.contains(e.target) && e.target.closest('.product-card__quick-add')) window.setTimeout(close, 50);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var nameInput = drawer.querySelector('[data-yh-wish-name]');
    if (nameInput) nameInput.addEventListener('change', function () { store(NAME_KEY, nameInput.value.trim()); });

    // A shared list link: /?wishlist=handle,handle&from=Name
    var params = new URLSearchParams(window.location.search);
    var sharedHandles = (params.get('wishlist') || '').split(',').map(function (h) { return h.trim(); }).filter(Boolean).slice(0, 30);
    if (sharedHandles.length) {
      Promise.all(sharedHandles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (products) {
        var items = products.filter(Boolean).map(function (p) {
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
          var single = p.variants && p.variants.length === 1;
          return { h: p.handle, t: p.title, p: money(p.price), i: img, u: '/products/' + p.handle, v: single && p.available ? String(p.variants[0].id) : '' };
        });
        open({ items: items, from: (params.get('from') || '').slice(0, 30) });
      });
    }
  }
  // A little envelope (or heart) flies from the product to the list button in the header,
  // so shoppers see where their wishes go.
  function fly(from) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = $$('[data-yh-wish-target]').filter(function (t) {
      var r = t.getBoundingClientRect();
      return r.width && r.bottom > 0 && r.top < window.innerHeight && window.getComputedStyle(t).opacity > 0.5;
    })[0];
    if (!target || !from.getBoundingClientRect || !document.body.animate) return;
    var a = from.getBoundingClientRect(), b = target.getBoundingClientRect();
    var icon = $$('svg', target).filter(function (g) { return !g.closest('.yhh-hat'); })[0];
    var dot = document.createElement('span');
    dot.className = 'yh-wish-fly';
    dot.setAttribute('aria-hidden', 'true');
    dot.innerHTML = icon ? icon.outerHTML : '';
    document.body.appendChild(dot);
    var x1 = a.left + a.width / 2, y1 = a.top + a.height / 2, x2 = b.left + b.width / 2, y2 = b.top + b.height / 2;
    var mx = (x1 + x2) / 2, my = Math.max(24, Math.min(y1, y2) - 80);
    dot.animate([
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(0.6)', opacity: 0 },
      { transform: 'translate(' + x1 + 'px,' + (y1 - 30) + 'px) scale(1.2)', opacity: 1, offset: 0.18 },
      { transform: 'translate(' + mx + 'px,' + my + 'px) scale(1) rotate(-12deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + x2 + 'px,' + y2 + 'px) scale(0.5)', opacity: 0.6 }
    ], { duration: 900, easing: 'cubic-bezier(.45,.05,.4,1)' }).onfinish = function () {
      dot.remove();
      target.classList.remove('is-catch'); void target.offsetWidth; target.classList.add('is-catch');
    };
  }

  // One-time tip under the "Santa list" button (shown on up to two visits, until dismissed or used)
  var tip = document.querySelector('[data-yh-wish-tip]');
  var TIP_KEY = 'yhWishTip';
  function hideTip(forever) {
    if (forever) store(TIP_KEY, '9');
    if (tip && !tip.hidden) tip.hidden = true;
  }
  if (tip && drawer && !list.length && !/[?&]wishlist=/.test(window.location.search)) {
    var seen = parseInt(store(TIP_KEY) || '0', 10) || 0;
    if (seen < 2) {
      window.setTimeout(function () {
        if (drawer.classList.contains('is-open') || window.scrollY > 300) return;
        store(TIP_KEY, String(seen + 1));
        tip.hidden = false;
        var btn = tip.parentNode.querySelector('.yhh-wish--santa');
        if (btn) btn.classList.add('is-glow');
        window.setTimeout(function () { hideTip(false); }, 14000);
      }, 5200);
    }
  }
  window.addEventListener('scroll', function () { if (tip && !tip.hidden && window.scrollY > 400) hideTip(false); }, { passive: true });

  window.YhWish = { has: has, toggle: toggle, open: open };
  syncHearts();
  document.addEventListener('shopify:section:load', syncHearts);

  /* ---------------- Free-shipping progress bar ---------------- */
  var goal = Y.freeShipping || 0;
  function updateBars(cart) {
    if (!goal || !cart) return;
    $$('[data-yh-shipbar]').forEach(function (bar) {
      if (!cart.item_count) { bar.hidden = true; return; }
      bar.hidden = false;
      var left = goal - cart.total_price;
      var pct = Math.max(4, Math.min(100, cart.total_price / goal * 100));
      var fill = bar.querySelector('[data-yh-shipbar-fill]');
      var rider = bar.querySelector('[data-yh-shipbar-rider]');
      var text = bar.querySelector('[data-yh-shipbar-text]');
      if (fill) fill.style.width = pct + '%';
      if (rider) rider.style.left = pct + '%';
      bar.classList.toggle('is-done', left <= 0);
      if (text) text.innerHTML = left > 0
        ? "You're <b>" + esc(money(left)) + '</b> away from free shipping' + (xmas ? ". Yoomi's sleigh is filling up!" : '')
        : '<b>Free shipping</b> unlocked!' + (xmas ? " Yoomi's sleigh is ready to fly 🎉" : ' 🎉');
    });
  }
  document.addEventListener('yoome:cart', function (e) { updateBars(e.detail); });
})();
